import AbstractPeriodColumn from "./AbstractPeriodColumn.js";

/**
 * Period change report column.
 */
class PeriodChangeColumn extends AbstractPeriodColumn {
	accept(visitor) {
		return visitor.visitPeriodChangeColumn(this);
	}

	_operation() {
		return "change";
	}

	static getType() {
		return "ChangeColumn";
	}
}

export default PeriodChangeColumn;
